// HousePricePageTypes
import { memo } from 'react';
import { Box, Grid, Tabs, Tab, useMediaQuery, Typography } from '@mui/material';

//styles
import styles from './styles';
import { useRouter } from 'next/router';
import theme from '@theme/index';

interface HousePricePageTypesProps {
  tabData: {
    id?: string;
    link?: string;
    typeName?: string;
  }[];
}

const HousePricePageTypes = ({ tabData }: HousePricePageTypesProps) => {
  const router = useRouter();
  const slug = router?.asPath;
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

  const tabValues = tabData?.map((data) => ({
    id: data?.id,
    label: data?.typeName,
    value: data?.typeName?.replace(/ /g, '-'),
    link: data?.link
  }));

  const filterTab = tabValues?.filter((data) => data?.link === slug);

  const activeTab = filterTab[0]?.value || 'Property-market-performance';

  return (
    <Grid container sx={styles.container}>
      <Box sx={styles.tabContainer}>
        <Tabs
          value={activeTab}
          allowScrollButtonsMobile
          variant="scrollable"
          scrollButtons={isSmallScreen}
        >
          {tabValues?.map((item) => (
            <Tab
              component="a"
              href={item.link}
              key={item?.value}
              label={
                <Typography variant="body1" component="span">
                  {item?.label}
                </Typography>
              }
              value={item?.value}
              sx={
                activeTab === item?.value
                  ? styles.selectedTabPill
                  : styles.tabPill
              }
            />
          ))}
        </Tabs>
      </Box>
    </Grid>
  );
};

export default memo(HousePricePageTypes);
